<template src='./moveEstablishmentModal.pug' lang='pug'></template>

<script>
import ConfirmModal from '../../modals/confirmModal/ConfirmModal'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import PATHS from '../../../router/routesMap.js'

export default {
  name: 'MoveEstablishmentModal',

  components: {
    ConfirmModal,
    ButtonPrimary
  },

  data () {
    return {
      disableButton: false,
      textModal: 'estabelecimentos.labels.confirmacaoMoverEstabelecimento'
    }
  },

  computed: {
    selectedEstablishmentsMoveEstablishment () {
      return this.$store.getters.selectedEstablishmentsMoveEstablishment
    }
  },

  methods: {
    confirmMoveEstablishment () {
      let data = {
        establishmentOrigin: this.selectedEstablishmentsMoveEstablishment.establishmentOrigin,
        establishmentDestiny: this.selectedEstablishmentsMoveEstablishment.establishmentDestiny,
        deleteEstablishmentOrigin: this.selectedEstablishmentsMoveEstablishment.deleteEstablishmentOrigin
      }

      this.$store.dispatch('loadingData').then(() => {
        this.disableButton = true
        this.$store.dispatch('moveEstablishment', data)
          .then((response) => {
            this.confirmReopenSuccess(response)
          })
          .catch((error) => {
            this.confirmReopenError(error)
          })
      })
    },

    // Acao tomada no sucesso da solicitacao
    confirmReopenSuccess (response) {
      this.disableButton = false
      this.$store.dispatch('cleanSelectedEstablishmentsMoveEstablishment')
      this.closeModal()
      this.$root.$refs.notification.global('S', this.$t(response.data.message))
      this.$store.dispatch('dataLoaded')
      this.$router.push(PATHS.LIST_ESTABLISHMENTS)
    },

    // Acao tomada no erro da solicitacao
    confirmReopenError (error = {}) {
      this.disableButton = false
      if (error && error.message === 'estabelecimentos.erro.excluirEstabelecimentoVinculado') {
        this.textModal = 'estabelecimentos.labels.apenasMoverLancamento'
        this.$store.dispatch('setSelectedEstablishmentsMoveEstablishment', {
          establishmentOrigin: this.selectedEstablishmentsMoveEstablishment.establishmentOrigin,
          establishmentDestiny: this.selectedEstablishmentsMoveEstablishment.establishmentDestiny,
          deleteEstablishmentOrigin: false
        })
      } else {
        this.closeModal()
      }
      this.$root.$refs.notification.global('E', error && error.data && error.data.message
        ? this.$t(error.data.message)
          : error && error.message
          ? this.$t(error.message)
        : this.$t('GENERAL'))
      this.$store.dispatch('dataLoaded')
    },

    closeModal () {
      $('#moveEstablishmentModal').modal('hide')
    }
  }
}
</script>



// WEBPACK FOOTER //
// MoveEstablishmentModal.vue?c519490a